// RefundPolicyMetaData.js
// RefundPolicyMetaData.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const RefundPolicyMetaData = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.meatbuddy.in/refund-policy/#webpage",
        "url": "https://www.meatbuddy.in/refund-policy",
        "name": "Refund Policy - Meat Buddy",
        "description": "Our comprehensive refund policy for fresh meat delivery service. Customer satisfaction guaranteed with hassle-free returns.",
        "isPartOf": { "@id": "https://www.meatbuddy.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://www.meatbuddy.in",
                "name": "Home"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "https://www.meatbuddy.in/refund-policy",
                "name": "Refund Policy"
              }
            }
          ]
        }
      },
      {
        "@type": "Article",
        "@id": "https://www.meatbuddy.in/refund-policy/#article",
        "headline": "Meat Buddy Refund and Return Policy",
        "description": "Clear guidelines on our refund process and customer satisfaction guarantee",
        "articleBody": "We process refunds within 48 hours for online payments and offer store credits for COD orders",
        "publisher": {
          "@type": "Organization",
          "@id": "https://www.meatbuddy.in/#organization",
          "name": "Meat Buddy",
          "url": "https://www.meatbuddy.in"
        },
        "datePublished": "2025-03-01",
        "dateModified": "2025-03-01"
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.meatbuddy.in/refund-policy/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How long does it take to process refunds?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "For online payments, refunds are processed within 48 hours. The amount may take 5-7 business days to reflect in your account depending on your bank."
            }
          },
          {
            "@type": "Question",
            "name": "What is your refund policy for COD orders?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "For Cash on Delivery (COD) orders, we offer store credits that can be used for future purchases."
            }
          },
          {
            "@type": "Question",
            "name": "What are the conditions for refund eligibility?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Refunds are provided for quality issues, wrong deliveries, or missing items when reported within 6 hours of delivery."
            }
          },
          {
            "@type": "Question",
            "name": "How do I request a refund?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Contact our customer support team with your order ID and reason for refund. We'll guide you through the process."
            }
          }
        ]
      },
      {
        "@type": "HowTo",
        "@id": "https://www.meatbuddy.in/refund-policy/#howto",
        "name": "How to Request a Refund",
        "description": "Step-by-step guide to requesting a refund for your order",
        "step": [
          {
            "@type": "HowToStep",
            "name": "Contact Support",
            "text": "Reach out to our customer support team within 6 hours of delivery"
          },
          {
            "@type": "HowToStep",
            "name": "Provide Details",
            "text": "Share your order ID and reason for refund request"
          },
          {
            "@type": "HowToStep",
            "name": "Documentation",
            "text": "If required, provide photos or videos of the issue"
          },
          {
            "@type": "HowToStep",
            "name": "Refund Processing",
            "text": "Our team will process your refund within 48 hours of approval"
          }
        ]
      }
    ]
  };

  return (
    <Helmet>
      <title>Refund Policy - Meat Buddy | Hassle-free Returns Guaranteed</title>
      <meta name="title" content="Refund Policy - Meat Buddy | Fresh Meat Delivery Service" />
      <meta name="description" content="Learn about Meat Buddy's hassle-free refund policy. Online payment refunds processed within 48 hours, store credits for COD orders. Quality satisfaction guaranteed or your money back." />
      <meta name="keywords" content="meat buddy refund policy, meat delivery refund, return policy, money back guarantee, refund process, COD refund policy" />
      <meta name="robots" content="noindex, follow" />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.meatbuddy.in/refund-policy" />
      <meta property="og:title" content="Refund Policy - Meat Buddy" />
      <meta property="og:description" content="Easy refunds guaranteed. 48-hour processing for online payments, store credits for COD orders. Quality assurance guaranteed." />
      
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Refund Policy - Meat Buddy" />
      <meta name="twitter:description" content="Hassle-free refunds guaranteed. Learn about our customer-friendly return and refund process." />
      
      <link rel="canonical" href="https://www.meatbuddy.in/refund-policy" />
      
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};